import { useState, useEffect } from 'react'

export default function WeatherWidget({ slot }) {
  const [weather, setWeather] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    // Get user's location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords

            // Using Open-Meteo API (free, no API key required)
            const response = await fetch(
              `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true&temperature_unit=celsius`
            )

            if (!response.ok) throw new Error('Failed to fetch weather')

            const data = await response.json()
            setWeather(data.current_weather)
            setLoading(false)
          } catch (err) {
            setError(err.message)
            setLoading(false)
          }
        },
        (err) => {
          setError('Location access denied')
          setLoading(false)
        }
      )
    } else {
      setError('Geolocation not supported')
      setLoading(false)
    }
  }, [])

  const getWeatherIcon = (weatherCode) => {
    // WMO Weather interpretation codes
    if (weatherCode === 0) return '☀️'
    if (weatherCode <= 3) return '⛅'
    if (weatherCode <= 48) return '🌫️'
    if (weatherCode <= 67) return '🌧️'
    if (weatherCode <= 77) return '❄️'
    if (weatherCode <= 82) return '🌧️'
    if (weatherCode <= 86) return '❄️'
    return '⛈️'
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '16px',
      }}
    >
      {loading && (
        <div style={{ fontSize: '16px' }}>Loading weather...</div>
      )}

      {error && (
        <div style={{ fontSize: '14px', textAlign: 'center' }}>
          <div>⚠️</div>
          <div style={{ marginTop: '8px', opacity: 0.8 }}>{error}</div>
        </div>
      )}

      {weather && !loading && !error && (
        <>
          <div style={{ fontSize: '64px', marginBottom: '8px' }}>
            {getWeatherIcon(weather.weathercode)}
          </div>
          <div style={{ fontSize: '48px', fontWeight: 'bold' }}>
            {Math.round(weather.temperature)}°C
          </div>
          <div style={{ fontSize: '14px', opacity: 0.8, marginTop: '8px' }}>
            Wind: {Math.round(weather.windspeed)} km/h
          </div>
          <div style={{ fontSize: '12px', opacity: 0.6, marginTop: '4px' }}>
            Local Weather
          </div>
        </>
      )}
    </div>
  )
}
